import { API_URL } from "./constants";

export const getHomepageData = (lang) => {
  return fetch(API_URL, { headers: { "Accept-Language": lang } }).then(
    (response) => response.json()
  );
};
